// extracted by mini-css-extract-plugin
export default {"noDataAvailable":"MarketDetail_noDataAvailable__BWwjz","generalInfoWrapper":"MarketDetail_generalInfoWrapper__4qlPF","generalInfo":"MarketDetail_generalInfo__8Lfqv"};